import QueryString from 'query-string'
import { SEARCH_FILTERS, SEARCH_FILTER_KEYS } from './filters.js'
import {
  MAX_DISTANCE_FILTER_SHORT_NAME,
  MIN_DISTANCE_FILTER_SHORT_NAME,
} from './moreFiltersContainer/distanceFilterConfig.js'

export const addToUrlPush = (valuesToAdd, urlToParse) => {
  let parsedURLParams = QueryString.parse(urlToParse)

  for (let i = 0; i < valuesToAdd.length; i++) {
    parsedURLParams[valuesToAdd[i].key] = valuesToAdd[i].value
  }

  let newQueryString = buildTheQueryString(parsedURLParams)

  //here we check for any default values and remove them

  return {
    string: newQueryString,
    paramArray: parsedURLParams,
  }
}

export const removeFromUrlPush = (fitlerShortNames, urlToParse) => {
  let parsedURLParams = QueryString.parse(urlToParse)

  for (let i = 0; i < fitlerShortNames.length; i++) {
    delete parsedURLParams[fitlerShortNames[i]]
  }

  let newQueryString = buildTheQueryString(parsedURLParams)

  return {
    string: newQueryString,
    paramArray: parsedURLParams,
  }
}

export const buildTheQueryString = (parsedURLParams) => {
  return Object.keys(parsedURLParams)
    .map((key) => key + '=' + parsedURLParams[key])
    .join('&')
}

export const formatFilterURLValues = (values) => {
  let urlValues = JSON.parse(JSON.stringify(values))

  const urlKeys = Object.keys(urlValues)

  for (const key of urlKeys) {
    if (SEARCH_FILTERS[key] && SEARCH_FILTERS[key].format_from_url) {
      urlValues[key] = SEARCH_FILTERS[key].format_from_url(urlValues[key])
    } else {
      delete urlValues[key]
    }
  }

  return urlValues
}

export const removeDefaults = (values) => {
  let filtersValues = JSON.parse(JSON.stringify(values))

  const filtersKeys = Object.keys(filtersValues)

  for (const key of filtersKeys) {
    let removeFilter = false

    const isDistanceFilter =
      key === MAX_DISTANCE_FILTER_SHORT_NAME ||
      key === MIN_DISTANCE_FILTER_SHORT_NAME

    if (!isDistanceFilter && SEARCH_FILTERS[key]?.is_default) {
      removeFilter = SEARCH_FILTERS[key].is_default(filtersValues[key])
    }
    if (removeFilter) {
      delete filtersValues[key]
    }
  }
  return filtersValues
}

export const formatForAPI = (values) => {
  let filtersValues = JSON.parse(JSON.stringify(values))

  const filtersKeys = Object.keys(filtersValues)

  let apiData = {}

  for (const key of filtersKeys) {
    if (!SEARCH_FILTER_KEYS?.includes(key)) {
      //remove things we don't filter for. weird url parameters, etc.
      delete filtersValues[key]
    }
  }
  for (const key of filtersKeys) {
    //format for the api call
    if (SEARCH_FILTERS[key].format_to_api) {
      let formattedValue = SEARCH_FILTERS[key].format_to_api(filtersValues[key])
      apiData = Object.assign(apiData, formattedValue)
    }
  }
  return apiData
}
